import { httpClient, KEM_BACKEND_API_URL } from "@ch/api";
import localforage from "localforage";
import { StorageNamesEnum } from "@ch/helpers/utils/enums";

export interface TranscribeResponse {
  text: string;
  url: string; // GCS URL of the uploaded audio
}

const uploadAndTranscribe = async (
  blob: Blob,
  filename = "voice-message.webm",
  userId?: string,
) => {
  const refreshToken = await localforage.getItem<string>(
    StorageNamesEnum.REFRESH_TOKEN,
  );
  const form = new FormData();
  form.append("file", blob, filename);

  return httpClient<TranscribeResponse>({
    baseURL: KEM_BACKEND_API_URL,
    url: "/transcribe/",
    method: "POST",
    data: form,
    params: userId ? { user_id: userId } : undefined,
    headers: {
      "X-Token": refreshToken ?? "",
    },
  });
};

export default uploadAndTranscribe;
